function removeUrlTrailingSlash(url) {
	if (typeof url !== 'string') return url

	while (url.endsWith('/')) {
		url = url.slice(0, -1) + ''
	}

	return url
}

export default removeUrlTrailingSlash
